Apt.fn.make('header', {
	/**
	 * Initialize module
	 *
	 * @returns {Object}
	 */
	init: function() {
		var priv = this.$private;

		$.screen.map([
			{
				max: 3,
				callback: function() {
					priv.initMobile();
				}
			},
			{
				min: 4,
				callback: function() {
					priv.initTablet();
				}
			}
		]);

		Apt.search.init();
	}
}, {
	/**
	 * Initialize mobile header
	 */
	initMobile: function() {
		var scope = this,
			$header = $$('header'),
			expandedClass = '-is-expanded',
			searchClass = '-is-search',
			state = false;

		$.events.reset('headerTablet');

		$header.addClass('-is-collapsible');

		$$('headerSearch').on('click.headerMobile', function() {
			state = state === 'search' ?
				false : 'search';

			$header.addClass(searchClass)
				.toggleClass(expandedClass, state);

			if (state) {
				Apt.search.focus();
			}
		});

		$$('headerPull').on('click', function() {
			state = state === 'nav' ?
				false : 'nav';

			$header.removeClass(searchClass)
				.toggleClass(expandedClass);
		}, {
			namespace: 'headerMobile'
		});

		$$('headerPrimary')
			.unbind()
			.on('click', function(e, el) {
				$(this).parent()
					.toggleClass(expandedClass);
			}, {
				cancel: true,
				namespace: 'headerMobile'
			});

		$($._win).on('pop', function() {
			state = false;
		});
	},

	/**
	 * Initialize tablet header
	 */
	initTablet: function() {
		var scope = this,
			activeClass = '-is-active',
			expandedClass = '-is-expanded',
			$links = $$('headerLink'),
			hideTimeout,
			$activeNav;

		$.events.reset('headerMobile');

		$$('header').removeClass(expandedClass + ' -is-collapsible');

		$links.on('click', function(e, el) {
			$links.removeClass(activeClass);
			$(el).addClass(activeClass);
		}, {
			namespace: 'headerTablet'
		});

		$$('headerPrimary')
			.removeAttr('data-static')
			.parent()
			.removeClass(expandedClass)
			.on({
				mouseenter: function(e, el) {
					var $el = $(el);

					Apt.search.blur();

					if ($activeNav && $el.is($activeNav)) {
						clearTimeout(hideTimeout);
					} else if ($activeNav) {
						$activeNav.removeClass(expandedClass);
					}

					$el.addClass(expandedClass);
					$activeNav = $el;
				},
				mouseleave: function(e, el) {
					hideTimeout = setTimeout(function() {
						$(el).removeClass(expandedClass);
					}, 150);
				}
			}, {
				namespace: 'headerTablet'
			});

		$$('headerSecondary').removeAttr('data-static')
			.parent()
			.removeClass(expandedClass);
	},

	/**
	 * Display series by style
	 *
	 * @param {Object} app
	 * @param {Array} series
	 * @param {String} slug
	 */
	displayStyle: function(app, series, slug) {
		app.$merge({
			activeSeries: 0,
			activeStyle: slug,
			series: series.filter(function(item) {
				return (item.styles || []).includes(slug);
			})
		});
	}
});